import { useTranslation } from "react-i18next";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Check, Zap, Users, Shield, TrendingUp, Bell, MessageSquare, BookOpen, ArrowRight } from "lucide-react";

const PricingFeatures = () => {
  const { t } = useTranslation();
  const features = [
    {
      icon: <Zap className="w-6 h-6" />,
      title: t('pricingFeatures.features.liveSignals.title'),
      description: t('pricingFeatures.features.liveSignals.description'),
    },
    {
      icon: <Users className="w-6 h-6" />,
      title: t('pricingFeatures.features.multipleTraders.title'),
      description: t('pricingFeatures.features.multipleTraders.description'),
    },
    {
      icon: <Shield className="w-6 h-6" />,
      title: t('pricingFeatures.features.riskManagement.title'),
      description: t('pricingFeatures.features.riskManagement.description'),
    },
    {
      icon: <TrendingUp className="w-6 h-6" />,
      title: t('pricingFeatures.features.successRate.title'),
      description: t('pricingFeatures.features.successRate.description'),
    },
    {
      icon: <Bell className="w-6 h-6" />,
      title: t('pricingFeatures.features.notifications.title'),
      description: t('pricingFeatures.features.notifications.description'),
    },
    {
      icon: <MessageSquare className="w-6 h-6" />,
      title: t('pricingFeatures.features.community.title'),
      description: t('pricingFeatures.features.community.description'),
    },
    {
      icon: <BookOpen className="w-6 h-6" />,
      title: t('pricingFeatures.features.education.title'),
      description: t('pricingFeatures.features.education.description'),
    },
    {
      icon: <Check className="w-6 h-6" />,
      title: t('pricingFeatures.features.exchanges.title'),
      description: t('pricingFeatures.features.exchanges.description'),
    },
  ];

  const included = [
    t('pricingFeatures.included.btc'),
    t('pricingFeatures.included.eth'),
    t('pricingFeatures.included.altcoins'),
    t('pricingFeatures.included.futures'),
    t('pricingFeatures.included.levels'),
    t('pricingFeatures.included.analysis'),
    t('pricingFeatures.included.guidelines'),
    t('pricingFeatures.included.support'),
  ];

  return (
    <section className="py-20 relative overflow-hidden">
      <div className="container px-4 relative z-10">
        <div className="text-center mb-16 space-y-4">
          <h2 className="text-4xl md:text-5xl font-bold">
            Everything You Need to <span className="bg-gradient-primary bg-clip-text text-transparent">Win in Crypto</span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Professional-grade signals, real-time alerts, expert risk management, and a thriving community — all working together to maximize your success
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {features.map((feature, index) => (
            <Card key={index} className="p-6 bg-card/30 backdrop-blur-xl border-border hover:border-primary/50 transition-all hover:scale-105">
              <div className="space-y-3">
                <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center text-primary">
                  {feature.icon}
                </div>
                <h3 className="text-lg font-semibold">{feature.title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">{feature.description}</p>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PricingFeatures;
